import {ACTION_CODE} from './_actionCode';
import {CustomerCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createCustomerCategory(userData: Record<string, any>, customerCategory: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createCustomerCategory - Start');

        const createCustomerCategoryResult = await CustomerCategoryService.createCustomerCategory(userData, customerCategory);

        LoggerService.logInfo('Action - createCustomerCategory - End - Success');

        return ResultModel.newSuccessResult(createCustomerCategoryResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createCustomerCategory - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création d‘une catégorie client.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
